import { ActionIcon, Anchor, Drawer, Tooltip } from '@mantine/core';
import { IconExternalLink, IconHelpCircle } from '@tabler/icons-react';
import { useState } from 'react';
import { Link } from 'react-router';
import { clanek as poId } from './clanki';
import { ClanekVsebina } from './ClanekVsebina';

/**
 * »?« ob funkciji: odpre članek pomoči v predalu ob strani, da uporabnik ne zapusti obrazca. {@code clanek} je id
 * članka ({@code src/pomoc/clanki/<id>.md}; test {@code pomoc.test.ts} preveri, da obstaja). {@code naTemnem} za
 * temno ozadje (npr. začetni zaslon).
 */
export function PomocIkona({ clanek, naTemnem = false }: { clanek: string; naTemnem?: boolean }) {
  const [odprto, setOdprto] = useState(false);
  const c = poId(clanek);
  if (!c) {
    return null;
  }
  return (
    <>
      <Tooltip label={`Pomoč: ${c.naslov}`}>
        <ActionIcon
          variant="subtle"
          color={naTemnem ? 'gray.0' : 'gray'}
          aria-label={`Pomoč: ${c.naslov}`}
          onClick={() => setOdprto(true)}
        >
          <IconHelpCircle size={18} />
        </ActionIcon>
      </Tooltip>
      <Drawer
        opened={odprto}
        onClose={() => setOdprto(false)}
        position="right"
        size="lg"
        title={c.naslov}
        styles={{ title: { fontWeight: 700, fontSize: 18 } }}
      >
        <Anchor component={Link} to={`/pomoc/${c.id}`} size="sm" onClick={() => setOdprto(false)}>
          <IconExternalLink size={14} style={{ verticalAlign: -2 }} /> Odpri v pomoči
        </Anchor>
        <div style={{ marginTop: 12 }}>
          <ClanekVsebina clanek={c} osnova="/pomoc" brezNaslova />
        </div>
      </Drawer>
    </>
  );
}
